module.exports = __webpack_public_path__ + "img/arh_4.131ab285.png";